<button type="button" class="btn" (click)="buttonClicked()" [ngClass]="'btn-' + type">
  <ng-content select="i.fa"></ng-content>
  {{ labelKey | translate}}
</button>
